var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/excel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0198 7.40213H24.7191V4.5L4.5 7.62462V35.0131L24.7191 38.5V34.1985H37.0198C37.3925 34.218 37.7577 34.0887 38.0352 33.8388C38.3128 33.589 38.4799 33.2391 38.5 32.866V8.73343C38.4796 8.36051 38.3123 8.01092 38.0348 7.76134C37.7573 7.51176 37.3923 7.38257 37.0198 7.40213ZM37.2141 33.0872H24.6778L24.6571 30.7906H27.6771V28.1158H24.6341L24.6195 26.5353H27.6771V23.8605H24.5964L24.5819 22.2799H27.6771V19.6052H24.5721V18.0246H27.6771V15.3498H24.5721V13.7693H27.6771V11.0945H24.5721V8.66292H37.2141V33.0872Z",
    fill: "#20744A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.5 10.5H36.5V13.3511H30.5V10.5ZM30.5 15.0372H36.5V17.8884H30.5V15.0372ZM30.5 19.5744H36.5V22.4256H30.5V19.5744ZM30.5 24.1116H36.5V26.9628H30.5V24.1116ZM30.5 28.6489H36.5V31.5H30.5V28.6489Z",
    fill: "#20744A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74801 14.0297L11.6406 13.8664L13.4589 18.7907L15.6074 13.6633L18.5 13.5L14.9874 20.4914L18.5 27.5L15.4416 27.2969L13.3767 21.9544L11.3104 27.0937L8.5 26.8495L11.7646 20.6587L8.74801 14.0297Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExcel);
export default __webpack_public_path__ + "static/media/ic_excel.64a3bbb1b64ab5a4873f5277565b3518.svg";
export { ForwardRef as ReactComponent };